import { useSelector } from "react-redux";
import SVGMapView from "modules/svgMapView";
import { Announcement } from "modules/announcement";
import { selectUser } from "modules/auth/redux/selectors";
import { makeSelectIsUserInTutorial } from "modules/userStatus/redux/selectors";
import { ShuffleAttendeesContainer } from "modules/shuffleAttendees/components/ShuffleAttendeesContainer";
import {
  selectCurrentTheaterId,
  selectTheaterTemplate,
} from "modules/theater/selectors";
import { isTypeOfIMapTemplate } from "modules/event/template";
import { selectCurrentEventId } from "modules/event/selectors";
import { SVG_HEIGHT, SVG_WIDTH } from "modules/event";
import { EnforceTableAssignmentContainer } from "modules/enforceTableAssignment";
import { EmbedContentSubscriber } from "modules/eventEmbedContent/components/EmbedContentSubscriber";
import { InEventSeatManagementDialog } from "modules/assignTables/components/InEventSeatManagementDialog";
import { selectShowAssignedShuffleDialog } from "modules/assignTables/redux";
import ConversationBroadcast from "modules/conversationBroadcast/ConversationBroadcast";
import useEventSplitTreatment from "modules/split/useEventSplitTreatment";
import { EventFeatures } from "services/splitService/features";

interface Props {
  isLoading: boolean;
}

export const ConversationModeWrapper = ({ isLoading }: Props) => {
  const showAssignedShuffleDialog = useSelector(
    selectShowAssignedShuffleDialog,
  );
  const { featureEnabled: videoAnnouncementFeature } = useEventSplitTreatment(
    EventFeatures.VIDEO_ANNOUNCEMENT,
  );
  const user = useSelector(selectUser);
  const isMeInTutorial = useSelector(
    makeSelectIsUserInTutorial(user?.id ?? ""),
  );

  const eventId = useSelector(selectCurrentEventId);
  const theaterId = useSelector(selectCurrentTheaterId);
  const spaceConfig = useSelector(selectTheaterTemplate);

  const blockContextMenu = (e: React.MouseEvent) => {
    e.preventDefault();

    return false;
  };

  if (!isTypeOfIMapTemplate(spaceConfig) || !theaterId || !eventId) {
    return null;
  }

  return (
    <>
      <div
        role="presentation"
        style={{
          backgroundColor: spaceConfig.backgroundColor,
          height: "100%",
        }}
      >
        <div
          role="presentation"
          onContextMenu={blockContextMenu}
          onContextMenuCapture={blockContextMenu}
          style={{
            outline: "none",
            width: spaceConfig.width ?? SVG_WIDTH,
            height: spaceConfig.height ?? SVG_HEIGHT,
            minHeight: "100%",
            backgroundColor: spaceConfig.backgroundColor,
          }}
        >
          <SVGMapView isLoading={isLoading} />
        </div>
      </div>

      <ShuffleAttendeesContainer />
      <EnforceTableAssignmentContainer />
      <EmbedContentSubscriber eventId={eventId} />
      {showAssignedShuffleDialog && (
        <InEventSeatManagementDialog eventId={eventId} />
      )}
      {!isMeInTutorial && user?.id && (
        <Announcement channel={theaterId} sender={user.id} />
      )}
      {!isMeInTutorial && user?.id && videoAnnouncementFeature && (
        <ConversationBroadcast />
      )}
    </>
  );
};
